module.exports = __webpack_public_path__ + "static/fonts/gothamlight.352d30a.ttf";